class OiProjectHighlights {
    private imgContainer: HTMLElement;
    private overlay: HTMLElement;
    private highlightImage: HTMLImageElement;
    private hotspots: HTMLElement[];
    private prevBtn: HTMLElement;
    private nextBtn: HTMLElement;
    private readonly resizeHandler: () => void | undefined;
    private circleWidth = '10vw';
    constructor(rootElement: HTMLElement) {
        this.imgContainer = rootElement.querySelector('.img-container');
        this.highlightImage = rootElement.querySelector('.highlight-image');console.log(this.highlightImage);
        this.overlay      = rootElement.querySelector('#overlay');
        this.hotspots     = Array.from(rootElement.querySelectorAll('.hotspot'));
        this.prevBtn      = rootElement.querySelector('.prev-btn');
        this.nextBtn      = rootElement.querySelector('.next-btn');

        if (!this.imgContainer || !this.overlay || this.hotspots.length === 0) return;

        this.resizeHandler = this.handleResize.bind(this) as () => void;
        window.addEventListener('resize', this.resizeHandler);

        this.init();
    }

    private init(): void {
        if (this.hotspots.length === 1) {
            this.prevBtn.style.pointerEvents = 'none';
            this.nextBtn.style.pointerEvents = 'none';
            this.prevBtn.style.opacity       = '0.5';
            this.nextBtn.style.opacity       = '0.5';
        }

        this.hotspots.forEach((hs) => {
            const imgEl = hs.querySelector<HTMLImageElement>('.preview-image');
            if (imgEl && hs.dataset.imgSrc) {
                imgEl.src = hs.dataset.imgSrc;
            }

            hs.addEventListener('click', (e) => {
                e.stopPropagation();
                this.hotspots.forEach(h => h.classList.remove('active'));
                hs.classList.add('active');
                this.highlightImage.style.clipPath = "circle("+this.circleWidth+" at "+ hs.dataset.left + "% " + hs.dataset.top + "%)";

                this.showOverlay(hs);
            });
        });

        if (this.hotspots.length > 1) {
            this.prevBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.navigate('prev');
            });
            this.nextBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.navigate('next');
            });
        }

        const closeBtn = this.overlay.querySelector('.close-btn');
        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.hideOverlay();
                this.highlightImage.style.clipPath = 'circle(0)';
            });
        }
    }

    private showOverlay(hotspot: HTMLElement): void {
        const wasHidden = this.overlay.classList.contains('hidden');
        if (wasHidden) {
            this.performShowAnimation(hotspot);
        } else {
            this.updateOverlay(hotspot);
        }
    }

    private performShowAnimation(hotspot: HTMLElement): void {
        const fullW    = this.imgContainer.clientWidth;
        const overlayW = fullW * 0.4;
        const leftPct  = parseFloat(hotspot.dataset.left || '0');
        const hotspotX = fullW * (leftPct / 100);
        const targetX  = overlayW + ((fullW - overlayW) / 2);
        let shift      = targetX - hotspotX;
        shift = Math.max(0, Math.min(shift, overlayW));
        this.imgContainer.style.transform = `translateX(${shift}px) scale(1.2)`;

        this.overlay.style.transition = 'none';
        const titleEl = this.overlay.querySelector<HTMLElement>('#overlay-title');
        const textEl  = this.overlay.querySelector<HTMLElement>('#overlay-text');
        if (titleEl) titleEl.textContent = hotspot.dataset.title || '';
        if (textEl)  textEl.innerHTML   = hotspot.dataset.text  || '';
        this.overlay.style.left       = '0';
        this.overlay.style.transform  = 'translateX(-100%)';
        this.overlay.classList.remove('hidden');

        this.overlay.offsetHeight;
        this.overlay.style.transition = 'transform 0.3s ease-in-out';
        requestAnimationFrame(() => {
            this.overlay.style.transform = 'translateX(0)';
        });
    }

    private updateOverlay(hotspot: HTMLElement): void {
        const fullW    = this.imgContainer.clientWidth;
        const overlayW = fullW * 0.4;
        const leftPct  = parseFloat(hotspot.dataset.left || '0');
        const hotspotX = fullW * (leftPct / 100);
        const targetX  = overlayW + ((fullW - overlayW) / 2);
        let shift      = targetX - hotspotX;
        shift = Math.max(0, Math.min(shift, overlayW));
        this.imgContainer.style.transform = `translateX(${shift}px) scale(1.2)`;

        const titleEl = this.overlay.querySelector<HTMLElement>('#overlay-title');
        const textEl  = this.overlay.querySelector<HTMLElement>('#overlay-text');
        if (titleEl) titleEl.textContent = hotspot.dataset.title || '';
        if (textEl)  textEl.innerHTML   = hotspot.dataset.text  || '';
    }

    private hideOverlay(callback?: () => void): void {
        this.overlay.style.transform       = 'translateX(-100%)';
        this.imgContainer.style.transform  = '';
        setTimeout(() => {
            this.overlay.classList.add('hidden');
            if (callback) callback();
        }, 300);
    }

    private navigate(dir: 'prev' | 'next'): void {
        const spots  = this.hotspots;
        const current = spots.find(hs =>
            hs.classList.contains('active')
        );
        if (!current) return;

        const idx     = spots.indexOf(current);
        const nextIdx = dir === 'next'
            ? (idx + 1) % spots.length
            : (idx - 1 + spots.length) % spots.length;

        spots.forEach(h => h.classList.remove('active'));

        const nextHs = spots[nextIdx];
        nextHs.classList.add('active');
        this.highlightImage.style.clipPath = "circle("+ this.circleWidth +" at "+ nextHs.dataset.left + "% " + nextHs.dataset.top + "%)";

        this.showOverlay(nextHs);
    }

    private handleResize(): void {
        if (!this.overlay.classList.contains('hidden')) {
            const activeHotspot = this.hotspots.find(h => h.classList.contains('active'));
            if (activeHotspot) {
                this.updateOverlay(activeHotspot);
            }
        }
    }
}

export default OiProjectHighlights;